export default {
  reset_password_title: "重置密碼",
  reset_pass_desc: "請輸入您的電子郵箱地址，我們將向您發送重置密碼的連結。",
  reset_pass: "重置密碼",
  reset_pass_requested: "已收到重置密碼請求",
  reset_pass_check_email: "請檢查您的電子郵箱並按照指示重置密碼。",
  reset_pass_email_sent_info: "如果此電子郵箱在我們的系統中存在，重置密碼的連結已發送。",
  reset_pass_did_not_receive: "沒有收到郵件？請檢查您的垃圾郵件資料夾。",
  reset_pass_resend_email: "重新發送重置密碼郵件",
  reset_pass_resend_available_in: "{seconds} 秒後可重新發送",
  reset_pass_resending: "正在重新發送...",
  reset_pass_resent_success: "重置密碼郵件重新發送成功",
  reset_pass_please_wait: "請等待 {seconds} 秒後再重新發送",
  reset_pass_request_failed: "重置密碼請求失敗",
  email_required: "請輸入您的電子郵箱地址",
  email_invalid: "請輸入有效的電子郵箱地址",
  email_placeholder: "your{0}example.com",
  daily_limit_reached: "已達到每日發送限制。請明天再試。",
  remaining_attempts: "今天還剩 {count} 次嘗試機會",
};
